import { IBankUserSetup, ResponseDataAdd } from '../models/bankUserSetup.model'

import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL || '' }

export const addNewBankUser = (data: IBankUserSetup): Promise<ResponseDataAdd> => {
  return axiosInstance.post(`/api/bankusers/create`, data, config)
}

export const getBankUserList = (payload: any) => {
  return axiosInstance.post(`/api/bankusers/filter`, JSON.stringify(payload), config)
}
export const getBankUserDetail = (id: any): Promise<any> => {
  return axiosInstance.get(`/api/bankusers/${id}`, config)
}

export const updateBankUser = (payload: IBankUserSetup,id: any): Promise<ResponseDataAdd> => {
  return axiosInstance.put(`/api/bankusers/update/${id}`, payload, config)
}

